import { IntervalReportRepository } from '@/models/Report/IntervalReport/IntervalReportRepository'

const actions = {
  async INIT_SEARCH_ITEMS({ commit }, advertiserId) {
    commit('SET_ADVERTISER_ID', advertiserId)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_KEYWORD({ commit }, keyword) {
    commit('SET_KEYWORD', keyword)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_PAGE_NO({ commit }, pageNo) {
    commit('SET_PAGE_NO', pageNo)
  },

  async SET_INTERVAL_REPORT({ commit }, { keyword, advertiserId, pageNo }) {
    commit('SET_LOADING_INTERVAL_REPORT', true)
    const intervalReport = await IntervalReportRepository.search(
      keyword,
      advertiserId,
      pageNo,
    )
    commit('SET_INTERVAL_REPORT', intervalReport)
    commit('SET_LOADING_INTERVAL_REPORT', false)
  },

  async RESET({ commit }) {
    commit('RESET')
  },
}

export default actions
